
<sidebar-layout-item class="cmp-product-info">
  <template v-if="productInfo.usecase === CF_USECASE.SERVER">
    <div
      class="server-case row q-col-gutter-md justify-between"
      :class="[desktop ? 'q-py-xl q-px-5xl' : 'q-pt-lg q-px-lg q-pb-xl']"
    >
      <div class="info-wrap col-shrink">
        <h5 class="q-mb-xs">
          {{ $t(`scf.${productInfo.usecase}_info.title`) }}
        </h5>
        <p class="q-mb-none text-ws-base110 ws-typo-xs">
          <span>{{ productInfo.cpuName }}</span>, <span>{{ productInfo.ram }}GB</span>,
          <span>{{ productInfo.primaryDrives }}</span>
        </p>
      </div>
      <div
        v-if="productInfo.usecase === CF_USECASE.SERVER"
        class="free-items row justify-between items-start"
      >
        <div class="free-item q-mr-3xl">
          <ws-icon name="on" :size="32" class="float-left q-mr-sm" />
          <span class="ws-typo-xs">
            <strong>
              {{ $t('scf.server_info.power', { count: 2, }) }}
            </strong>
          </span>
        </div>

        <div class="free-item">
          <ws-icon name="ethernet_on" :size="32" class="float-left q-mr-sm" />
          <span class="ws-typo-xs">
            <strong>
              {{ $t('scf.server_info.network', { count: 2, }) }}
            </strong>
          </span>
        </div>
      </div>

      <div
        class="q-mt-xl row justify-between items-center full-width q-pt-none"
      >
        <div class="col-7">
          <ws-select
            v-model="selectedPeriod"
            :options="periodOptions"
            map-options
          >
            <template
              v-for="slotName in ['option', 'selected-item']"
              :slot="slotName"
              slot-scope="scope"
            >
              <q-item
                :key="slotName + scope.index"
                v-bind="scope.itemProps"
                v-on="scope.itemEvents"
              >
                <q-item-section>
                  <q-item-label>
                    {{
                      $t('uikit:general.period.months', {
                        count: scope.opt,
                      })
                    }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </ws-select>
        </div>
        <price-period
          class="product-price"
          :prices="productInfo.prices"
          :period="selectedPeriod"
          :period-under="productInfo.usecase === CF_USECASE.SERVER"
          :verbose="productInfo.usecase === CF_USECASE.SERVER"
        />
      </div>
    </div>
  </template>

  <!-- Currently just CF_USECASE.MONITORING -->
  <template v-else>
    <div
      class="others-case row items-center justify-between q-col-gutter-x-md"
      :class="{
        'q-py-xl q-px-5xl': desktop,
        'q-pa-lg': tablet,
        'q-pa-md': mobile,
      }"
    >
      <h5 class="col q-mb-none">
        {{ $t(`scf.${productInfo.usecase}_info.title`) }}
      </h5>
      <price-period
        class="product-price float-right"
        from
        verbose
        :prices="productInfo.prices"
        :period="selectedPeriod"
      />
    </div>
  </template>
</sidebar-layout-item>
